<template lang="pug">
  e-chart(
    :header="`${documentTitle}`"
    :options="chartCountGarbageOptions"
    :series="chartCountGarbageSeries"
    chartId="garbage"
    :chartRedirectParams="chartRedirectParams"
      :chartLoading="chartLoading"
  :chartError="chartError"
  )
    template(slot="chartHeader")
      .default-select.part-1-from-1
        e-select(
        class="dropdown-btn"
        tabView="tab1"
        :model="fields.garbage"
        name="viewMode"
        :options="chartViewModeOptions"
        )
      .default-select.part-1-from-4
        e-select(
          class="dropdown-btn"
          tabView="tab1"
          :model="fields"
          name="garbageType"
          :options="chartCountGarbageTypeOptions"
        )
      .default-select.part-1-from-4
        e-select(
          class="dropdown-btn"
          tabView="tab1"
          :model="fields"
          name="garbageYear"
          :options="chartYearOptions"
        )
</template>

<script>
  import {WasteGenerators, Formed, Burial, Processing, Storage, Neutralization, Utilization, Located} from '../../../config/config'
  import chartsMixin from '../mixins/charts-mixin.js'

  export default {
    mixins: [chartsMixin],
    created () {
      this.chartCountGarbageOptions = this.getCurrentChartOptions
      this.fetchData()
    },
    watch: {
      'fields.garbage.viewMode': {
        handler: function(v) {
          if(v === WasteGenerators){
            this.fields.garbageType = Formed
          }
          this.viewMode = v
          this.fetchData()
        }
      },
      'fields.garbageYear': 'fetchData',
      'fields.garbageType': 'fetchData'
    },
    computed: {
      chartCountGarbageTypeOptions () {
        return this.fields.garbage.viewMode === WasteGenerators ?
          [
            {id: Formed, name: 'образовано'},
            {id: Burial, name: 'захоронено'},
            {id: Processing, name: 'обработано'},
            {id: Storage, name: 'на хранение'},
            {id: Neutralization, name: 'обезврежено'},
            {id: Utilization, name: 'утилизировано'}
          ] : [
            {id: Located, name: 'размещено'},
            {id: Formed, name: 'образовано'},
            {id: Processing, name: 'обработано'},
            {id: Neutralization, name: 'обезврежено'},
            {id: Utilization, name: 'утилизировано'}
          ]
      },
      viewMode: {
        get: function () {
          return this.$store.getters.charts.garbage.viewMode
        },
        set: function (newValue) {
          this.$store.commit('charts', {garbage: {viewMode: newValue}})
        },
      },
      getCurrentChartOptions () {
        return this.getChartOptions('garbage')
      }
    },
    methods: {
      buildEndpoint () {
        return this.getEndpoint()({
          query: {
            type: 'danger',
            year: this.fields.garbageYear,
            action: this.fields.garbageType,
            viewMode: this.viewMode
          }
        })
      },
      fetchData () {
        this.fetchChartData().then(r => {
          this.chartCountGarbageSeries = this.transform(r)
          this.createAndSetCats(r, this.chartCountGarbageSeries)
        })
      },
      createAndSetCats (r, series = []) {
        let cats = []
        series[0].data.forEach(v => {
          cats.push(`${v.name}`)
        })
        let options = Object.assign({}, this.chartCountGarbageOptions)
        options.xAxis.categories = cats
        this.chartCountGarbageOptions = Object.assign({}, options)
      }
    }
  }
</script>
